export default {
  isAuthenticated: false,
  token: null,
  patientToken: null
}



//////////////////
// WEBPACK FOOTER
// ../raypro_ui/src/store/modules/auth/state.js
// module id = null
// module chunks = 